module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h4', [_vm._v("Create a new Coordinator")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateCoordinator($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "coordinatorName",
      "label": "Name",
      "id": "coordinatorName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.coordinatorName),
      callback: function($$v) {
        _vm.coordinatorName = $$v
      },
      expression: "coordinatorName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "coordinatorPhone",
      "label": "Phone Number",
      "id": "coordinatorPhone",
      "single-line": ""
    },
    model: {
      value: (_vm.coordinatorPhone),
      callback: function($$v) {
        _vm.coordinatorPhone = $$v
      },
      expression: "coordinatorPhone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "coordinatorEmail",
      "label": "Email Address",
      "id": "coordinatorEmail",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.coordinatorEmail),
      callback: function($$v) {
        _vm.coordinatorEmail = $$v
      },
      expression: "coordinatorEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n              Create Coordinator\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-648ab338","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Coordinators/CreateCoordinator.vue
// module id = 690
// module chunks = 1